import { useState, useCallback } from 'react';
import { Input, InputNumber, AutoComplete } from 'antd';

// 根据传入配置渲染通用文本、数字或自动完成输入框
export default function InputItem({
  label = '',
  require = false,
  placeholder = '',
  type = 'text',
  onChange,
  value,
  className = '',
  prefix = '',
  suffix = '',
  min = 0,
  max,
  precision,
  disabled = false,
  maxLength,
  options = [],
}) {
  const [status, setStatus] = useState('normal');
  const onBlur = useCallback(() => {
    // 0 也算有效输入
    if (require && (value === '' || value === undefined || value === null)) {
      setStatus('error');
    } else {
      setStatus('normal');
    }
  }, [require, value]);

  const getPlaceholder = useCallback(() => {
    if (!placeholder && type === 'text' && label) return `请输入${label}`;
    if (!placeholder && (type === 'number' || type === 'money') && label)
      return `请输入${label}`;
    return placeholder;
  }, [label, placeholder, type]);

  const isNumberType = type === 'number' || type === 'money';

  // money 类型输入自动保留2位小数
  const handleNumberChange = (val) => {
    if (type === 'money' && typeof val === 'number') {
      // 只保留2位小数
      const fixed = Number(val.toFixed(2));
      onChange(fixed);
    } else {
      onChange(val);
    }
  };

  return (
    <div className={`flex flex-col items-start ${className}`}>
      <label className="block text-sm font-medium text-gray-600 mb-1">
        {require && <span className="text-red-500 mr-1">*</span>}
        {label}
      </label>
      <div className="w-full">
        {isNumberType && (
          <InputNumber
            status={status}
            prefix={type === 'money' ? '¥' : prefix}
            suffix={suffix}
            value={value}
            placeholder={getPlaceholder()}
            onBlur={onBlur}
            onChange={handleNumberChange}
            min={min}
            max={max}
            precision={precision}
            disabled={disabled}
            className="w-full h-10"
            maxLength={maxLength}
          />
        )}
        {!!options.length && (
          <AutoComplete
            options={options}
            placeholder={getPlaceholder()}
            showSearch={{
              filterOption: (inputValue, option) =>
                option.value.includes(inputValue),
            }}
            value={value}
            onChange={(e) => onChange(e)}
            className="min-w-20 w-full h-10 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        )}
        {!isNumberType && !options.length && (
          <Input
            status={status}
            prefix={prefix}
            suffix={suffix}
            type={type}
            value={value}
            placeholder={getPlaceholder()}
            onBlur={onBlur}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            className="w-full h-10 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            maxLength={maxLength}
          />
        )}
      </div>
    </div>
  );
}
